import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Wrapper, Container, Content, DataContent, Overlay } from "./index.style";
import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import EnvironmentBanner from "../../components/environmentBanner";
import { navLinks } from "./links";
import { useDispatch } from "react-redux";
import { getUserProfile } from "../../redux/authSlice";

const AdminLayout = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [sidebarOpen, setSidebarOpen] = useState(false);

	useEffect(() => {
		dispatch(getUserProfile(navigate));
		const authUser = JSON.parse(localStorage.getItem("authUser"));
		if (!authUser) {
			navigate("/login");
		}
	}, [navigate]);

	const toggleSidebar = () => setSidebarOpen((prev) => !prev);
	const closeSidebar = () => setSidebarOpen(false);

	return (
		<Wrapper>
			<EnvironmentBanner />
			<Content>
				<Sidebar data={navLinks} isOpen={sidebarOpen} onClose={closeSidebar} />
				{sidebarOpen && <Overlay onClick={closeSidebar} />}
				<Container>
					<Header onMenuClick={toggleSidebar} />
					<DataContent>
						<Outlet />
					</DataContent>
				</Container>
			</Content>
		</Wrapper>
	);
};

export default AdminLayout;
